import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export function ThemeToggle({ className = "text-blue-100 hover:bg-white/10" }: { className?: string }) {
  const { theme, setTheme } = useTheme();

  return (
    <button
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      className={`relative p-2.5 rounded-xl transition-all overflow-hidden ${className}`}
      title={theme === 'dark' ? "Mudar para Modo Claro" : "Mudar para Modo Escuro"}
    >
      <div className="relative w-5 h-5 flex items-center justify-center">
        <Sun 
          className={`absolute transition-all duration-300 ease-in-out ${
            theme === 'dark' 
              ? 'opacity-0 rotate-90 scale-50' 
              : 'opacity-100 rotate-0 scale-100'
          }`} 
          size={20} 
        />
        <Moon 
          className={`absolute transition-all duration-300 ease-in-out ${
            theme === 'dark' 
              ? 'opacity-100 rotate-0 scale-100' 
              : 'opacity-0 -rotate-90 scale-50'
          }`} 
          size={20} 
        />
      </div>
    </button>
  );
}
